<template>
  <div class="csv-example">
    <div class="csv-header">
      <span class="csv-col">SKU</span>
      <span class="csv-col">ASIN</span>
      <span class="csv-col">Product Name</span>
      <span class="csv-col">Current Price</span>
      <span class="csv-col highlight">COGS</span>
      <span class="csv-col highlight">Other Costs</span>
    </div>
    <div class="csv-row">
      <span class="csv-col">SKU-12345</span>
      <span class="csv-col">B07K8XYZ</span>
      <span class="csv-col">"Argan Body Wash"</span>
      <span class="csv-col">24.99</span>
      <span class="csv-col highlight"><strong>8.50</strong></span>
      <span class="csv-col highlight"><strong>2.00</strong></span>
    </div>
    <div class="csv-row">
      <span class="csv-col">SKU-67890</span>
      <span class="csv-col">B08SM5NNQ</span>
      <span class="csv-col">"Body Lotion"</span>
      <span class="csv-col">19.99</span>
      <span class="csv-col highlight"><strong>5.25</strong></span>
      <span class="csv-col highlight"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CSVExample'
}
</script>

<style scoped>
@import './styles/CSVExample.css';
</style>




// WEBPACK FOOTER //
// CSVExample.vue?248c4ddc